import { useContext, useMemo } from 'react';
import { AuthenticatedUserContext } from "@ngt/forms";
import { IUserDto, UserDto } from '../api/dtos';

export const useAuthenticatedUser = <TUser = IUserDto>() => {
    const { data } = useContext(AuthenticatedUserContext);

    const user: TUser | undefined = useMemo(() => {
        
        return data as TUser | undefined;

    }, [data])

    return user as UserDto;
}
